import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { maybeRunAutoSnapshot } from '@/services/autoSnapshot';

const isDesktop = !!window.psbDesktop?.isDesktop;

// 挂载后先等一会儿再查首次（让登录态/口令输入稳定下来），之后每 30 分钟查一次
const FIRST_CHECK_DELAY_MS = 30 * 1000;
const CHECK_INTERVAL_MS = 30 * 60 * 1000;

/**
 * 每日自动加密快照调度：应用开着、已登录、已解锁（本会话输入过同步口令）、
 * 云端已绑定且距上次尝试 >24h 时，静默走一次 export→encrypt→push 管线。
 * 仅桌面端生效；细节见 services/autoSnapshot.ts。
 */
export const useAutoSnapshot = (): void => {
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (!isDesktop || !isLoggedIn) return;
    const first = setTimeout(() => { void maybeRunAutoSnapshot(); }, FIRST_CHECK_DELAY_MS);
    const timer = setInterval(() => { void maybeRunAutoSnapshot(); }, CHECK_INTERVAL_MS);
    return () => {
      clearTimeout(first);
      clearInterval(timer);
    };
  }, [isLoggedIn]);
};
